import React, { useEffect, useState } from "react";
import axios from "axios";

function Enquiry_From() {

    const[customerEnquiry,setCustomerEnquiry] = useState([]);
      const [searchTerm, setSearchTerm] = useState('');

   const fecthEnquiry = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-enquiry');
            const data = res.data;
            setCustomerEnquiry(data);
            console.log(data);
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
       fecthEnquiry();
    }, [])

      const filteredData = customerEnquiry.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )
  return (
    <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
           

                  <h3 className='my-3 fw-bold fs-5 golos'>Customer Enquiry List</h3>
                   <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">
                  
                            <div className="mb-2 w-50 w-md-50 pe-md-2">
                              <input
                                className="form-control w-100"
                                list="datalistOptions"
                                placeholder="Search ...."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                  
                          
                          </div>
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                                      <table className="table table-bordered table-striped text-center table-sm align-middle">
                                          <thead className="table-info">
                                              <tr>
                                                  <th>SN No</th>
                                                  <th> Name</th>
                                                  <th>Email</th>
                                                  <th>Description </th>
                                                 
                  
                                              </tr>
                                          </thead>
                                          <tbody>
                                                        {filteredData.length > 0 ? (
                                                          filteredData.map((c, index) => (
                                                            <tr key={index}>
                                                              <td>{index + 1}</td>
                                                              <td >{c.name}</td>
                                                              <td>{c.email} </td>
                                                              <td className='text-wrap'>{c.description}</td>
                                                             
                                                             
                                                            </tr>
                                                          ))) : (
                                                          <tr>
                                                            <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                  
                                      </table>
                                  </div>
        </div>
    </div>
  )
}

export default Enquiry_From